/* eslint-disable no-undef */
import React, { useRef } from "react";
import { connect } from "react-redux";
import Layout from "../../Components/Layout";
import SettingsLayout from "./SettingsLayout";
import { closePanel, openPanel } from "../../Redux/Panels/RightPanel/actions";
import Api from "../../Server/Api";
import InfoActionPage from "../../Components/InfoActionPage";
import { FormContent } from "../../Components/FormContent";
import { useParams } from "react-router-dom";
import { PaymentButton } from "../patient/PaymentButton";

const api = new Api();

export const structure = [
	{
		title: "Patient Info",
		description: "Enter patient's personal information and login details.",
		fields: [
			{
				name: "name",
				label: "Name",
				icon: "user",
				width: 12,
				required: true,
			},
			{
				name: "email",
				label: "Email",
				icon: "mail",
				width: 12,
				readOnly: true,
				// required: true
			},
			{
				name: "phone",
				label: "Phone",
				icon: "phone",
				width: 12,
				required: true,
				readOnly: true,
			},
			{
				name: "age",
				label: "Age",
				width: 12,
				required: true,
			},
			{
				name: "weight",
				label: "Weight (kG)",
				width: 12,
				required: true,
			},
			{
				name: "height",
				label: "Height (cm)",
				width: 12,
				required: true,
			},
			{
				name: "blood_group",
				label: "Blood Group",
				width: 12,
				required: true,
				type: "select",
				options: [
					{ value: "", label: "---Select---" },
					{ value: "O+", label: "O+" },
					{ value: "O-", label: "O-" },
					{ value: "A+", label: "A+" },
					{ value: "B+", label: "B+" },
				],
			},
		],
	},
	{
		title: "Doctor's Info",
		description: "Please tell us about your doctor if you have one.",
		fields: [
			{
				name: "doctor_name",
				label: "Name",
				icon: "user",
				width: 12,
			},
			{
				name: "doctor_email",
				label: "Email",
				icon: "mail",
				width: 12,
			},
			{
				name: "doctor_phone",
				label: "Phone",
				icon: "phone",
				width: 12,
			},
		],
	},
	{
		title: "Medical History",
		description: "Please enter your medical history record.",
		sectionClass: "w-100",
		fields: [
			{
				name: "main_issue",
				label: "Main issue that you need second opinion for",
				icon: "user",
				width: 12,
				type: "textarea",
				required: true,
			},
			{
				name: "what_done",
				label: "What have you done so far about it",
				icon: "user",
				width: 12,
				type: "textarea",
			},
			{
				name: "investigation_done",
				label: "Investigation done so far",
				icon: "user",
				width: 12,
				type: "textarea",
			},
			{
				name: "investigation_duration",
				label: "How long has this going on?",
				icon: "clock",
				width: 12,
			},
			{
				name: "past_medical_history",
				label: "Past medical history( list your past medical conditions)",
				icon: "user",
				width: 12,
				type: "textarea",
			},
			{
				name: "past_surgical_history",
				label:
					"Past surgical history ( have you had any surgery in the past please list)",
				icon: "user",
				width: 12,
				type: "textarea",
			},
			{
				name: "obstetrics_gynaecology_history",
				label: "Obstetrics and gynaecology history",
				icon: "user",
				width: 12,
				type: "textarea",
			},
			{
				name: "paediatric_history",
				label:
					"Paediatric history ( developmental, birth history, immunization hx)",
				icon: "user",
				width: 12,
				type: "textarea",
			},
			{
				name: "family_history",
				label:
					"Family history ( medical condition in family, sudden death, stroke, DM etc)",
				icon: "user",
				width: 12,
				type: "textarea",
			},
			{
				name: "socio_history",
				label: "Socio History ( smoke/ alcohol)",
				icon: "user",
				width: 12,
				type: "textarea",
			},
			{
				name: "list_of_medication",
				label: "List of medication",
				icon: "user",
				width: 12,
				type: "textarea",
			},
		],
	},
	{
		title: "Cardiovascular",
		sectionClass: "w-100",
		fields: [
			{
				type: "checkbox-list",
				items: [
					{
						name: "Chest Pain",
						key: "chest_pain",
					},
					{
						name: "Shortness of breath",
						key: "shortness_of_breath",
					},
					{
						name: "Swelling of the feet",
						key: "swelling_of_the_feet",
					},
					{
						name: "Racing Pulse",
						key: "racing_pulse",
					},
					{
						name: "Irregular heart beat",
						key: "irregular_heart_beat",
					},
					{
						name: "None",
						key: "none_cardiovascular",
					},
				],
			},
			{
				name: "is_blood_pressure_under_control",
				label: "Is your blood pressure under control?",
				width: 12,
				type: "select",
				options: [
					{ value: "", label: "---Select---" },
					{ value: "Yes", label: "Yes" },
					{ value: "No", label: "No" },
					{ value: "Unsure", label: "Unsure" },
				],
			},
		],
	},
	{
		title: "Endocrine",
		sectionClass: "w-100",
		fields: [
			{
				type: "checkbox-list",
				items: [
					{
						name: "Excess thirst",
						key: "excess_thirst",
					},
					{
						name: "Excessive urination",
						key: "excessive_urination",
					},
					{
						name: "Heat Intolerance",
						key: "heat_intolerance",
					},
					{
						name: "Cold Intolerance",
						key: "cold_intolerance",
					},
					{
						name: "Hair loss",
						key: "hair_loss",
					},
					{
						name: "Dry skin",
						key: "dry_skin",
					},
					{
						name: "None",
						key: "none_cardiovascular",
					},
				],
			},
			{
				name: "is_blood_sugar_under_control",
				label: "Is your blood sugar under control?",
				width: 12,
				type: "select",
				options: [
					{ value: "", label: "---Select---" },
					{ value: "Yes", label: "Yes" },
					{ value: "No", label: "No" },
					{ value: "Unsure", label: "Unsure" },
				],
			},
		],
	},
	{
		title: "Gastrointestinal",
		sectionClass: "w-100",
		fields: [
			{
				type: "checkbox-list",
				items: [
					{
						name: "Abdominal pain",
						key: "abdominal_pain",
					},
					{
						name: "Nausea",
						key: "nausea",
					},
					{
						name: "Diarrhea",
						key: "diarrhea",
					},
					{
						name: "Bloody stools",
						key: "bloody_stools",
					},
					{
						name: "Stomach Ulcers",
						key: "stomach_ulcers",
					},
					{
						name: "Constipation",
						key: "constipation",
					},
					{
						name: "Trouble Swallowing",
						key: "trouble_swallowing",
					},
					{
						name: "Jaundice/Yellow skin",
						key: "jaundice_yellow_skin",
					},
					{
						name: "None",
						key: "none_gastrointestinal",
					},
				],
			},
		],
	},
	{
		title: "Integumentary",
		sectionClass: "w-100",
		fields: [
			{
				type: "checkbox-list",
				items: [
					{
						name: "Rash",
						key: "rash",
					},
					{
						name: "Change in mole",
						key: "change_in_mole",
					},
					{
						name: "Skin sores",
						key: "skin_sores",
					},
					{
						name: "Skin cancer",
						key: "skin_cancer",
					},
					{
						name: "Severe itching",
						key: "sever_itching",
					},
					{
						name: "Loss of hair",
						key: "loss_of_hair",
					},
					{
						name: "None",
						key: "none_integumentary",
					},
				],
			},
		],
	},
	{
		title: "Constitutional",
		sectionClass: "w-100",
		fields: [
			{
				type: "checkbox-list",
				items: [
					{
						name: "Fever",
						key: "fever",
					},
					{
						name: "Weight loss",
						key: "weight_loss",
					},
					{
						name: "Fatigue",
						key: "fatigue",
					},
					{
						name: "Loss of Appetite",
						key: "loss_of_appetite",
					},
					{
						name: "Chills",
						key: "chills",
					},
					{
						name: "Night Sweats",
						key: "night_sweats",
					},
					{
						name: "Poor appetite",
						key: "poor_appetite",
					},
					{
						name: "None",
						key: "none_constitutional",
					},
				],
			},
		],
	},
	{
		title: "Genitourinary",
		sectionClass: "w-100",
		fields: [
			{
				type: "checkbox-list",
				items: [
					{
						name: "Genital sores or ulcers",
						key: "genital_sores_ulcers",
					},
					{
						name: "Kidney Failure/Problems",
						key: "kidney_failure_problems",
					},
					{
						name: "Kidney stones",
						key: "kidney_stones",
					},
					{
						name: "Painful/difficult urination (Prostatitis)",
						key: "paintful_urination",
					},
					{
						name: "Testicular pain",
						key: "testicular_pain",
					},
					{
						name: "Urinary discharge",
						key: "urinary_discharge",
					},
					{
						name: "None",
						key: "none_genitourinary",
					},
				],
			},
		],
	},
	{
		title: "Hematology/Oncology",
		sectionClass: "w-100",
		fields: [
			{
				type: "checkbox-list",
				items: [
					{
						name: "Easy bruising",
						key: "easy_bruising",
					},
					{
						name: "Prolonged bleeding",
						key: "prolonged_bleeding",
					},
					{
						name: "None",
						key: "none_hematology_oncology",
					},
				],
			},
		],
	},
	{
		title: "HENT",
		sectionClass: "w-100",
		fields: [
			{
				type: "checkbox-list",
				items: [
					{
						name: "Hearing loss",
						key: "hearing_loss",
					},
					{
						name: "Sore throat",
						key: "sore_throat",
					},
					{
						name: "Runny nose",
						key: "runny_nose",
					},
					{
						name: "Dry mouth",
						key: "dry_mouth",
					},
					{
						name: "Jaw Claudication (pain in jaw when chewing)",
						key: "jaw_claudication",
					},
					{
						name: "Ear ache",
						key: "ear_ache",
					},
					{
						name: "None",
						key: "none_hematology_oncology",
					},
				],
			},
		],
	},
	{
		title: "Neurologic",
		sectionClass: "w-100",
		fields: [
			{
				type: "checkbox-list",
				items: [
					{
						name: "Weakness",
						key: "headaches",
					},
					{
						name: "Scalp tenderness",
						key: "scalp_tenderness",
					},
					{
						name: "Dizziness",
						key: "dizziness",
					},
					{
						name: "Paralysis of extremities",
						key: "paralysis_of_extremities",
					},
					{
						name: "Tremor",
						key: "tremor",
					},
					{
						name: "Stroke",
						key: "stroke",
					},
					{
						name: "Numbness or tingling",
						key: "numbness_or_tingling",
					},
					{
						name: "Seizures or convulsions",
						key: "seizures_or_convulsions",
					},
					{
						name: "Fainting",
						key: "fainting",
					},
					{
						name: "None",
						key: "none_neurologic",
					},
				],
			},
		],
	},
	{
		title: "Respiratory",
		sectionClass: "w-100",
		fields: [
			{
				type: "checkbox-list",
				items: [
					{
						name: "Wheezing",
						key: "wheezing",
					},
					{
						name: "Cough",
						key: "cough",
					},
					{
						name: "Coughing up blood",
						key: "coughing_blood",
					},
					{
						name: "Severe or Frequent colds",
						key: "severe_frequent_colds",
					},
					{
						name: "Difficulty breathing",
						key: "difficulty_breathing",
					},
					{
						name: "None",
						key: "none_respiratory",
					},
				],
			},
		],
	},
];
export const defaultMsg = {
	title: "Medical Record Submitted",
	message: `Thank you for submitting your medical record form for easy accessment, one of our doctors will contact you shortly. `,
	image: require("../../assets/images/undraw_order_confirmed_re_g0if.svg")
		.default,
	action: {
		text: "Contact Us",
		action: () => {
			window.open("https://24telemed.org/contact");
		},
	},
};

const MedicalProfile2ndOpinion = (props) => {
	const { identifier } = useParams();
	const [DATA, setDATA] = React.useState({});
	const [booking, setBooking] = React.useState({});
	const [view, setView] = React.useState(0);
	const [message, setMessage] = React.useState(defaultMsg);
	const [page, setPage] = React.useState(0);
	const [loading, setLoading] = React.useState(true);

	const paystack = useRef(null);

	const updateProfile = (d) => {
		setDATA({ ...DATA, ...d });
	};

	const init = async () => {
		setLoading(true);
		const res = await api.get({
			endpoint: `/second-opinion/${identifier}/booking_details/`,
		});
		if (res?.id > 0) {
			if (res?.state === "COMPLETED") {
				setMessage({
					title: "Record Already Submitted",
					message: `Your medical profile is already submitted. We will get back to you short! If you want to contact us now, you can click the button below.`,
					image:
						require("../../assets/images/undraw_order_confirmed_re_g0if.svg")
							.default,
					action: {
						text: "Contact Us",
						action: () => {
							window.open("https://24telemed.org/contact");
						},
					},
				});
				setView(1);
			} else {
				setDATA(res?.data);
				setBooking(res);
				if (res?.paymentRequired) {
					setTimeout(() => {
						paystack.current && paystack.current.pay();
					}, 1000);
				}
			}
		} else {
			setMessage({
				title: "Booking Not Found",
				message: `Sorry we could not find your booking reference, please check your email or start a need booking from our main website. `,
				image: require("../../assets/images/undraw_order_confirmed_re_g0if.svg")
					.default,
				action: {
					text: "Start New Booking",
					action: () => {
						window.open("https://24telemed.org/service/medical-2nd-opinion");
					},
				},
			});
			setView(1);
		}
		setLoading(false);
	};

	React.useEffect(() => {
		init();
	}, []);

	const pageValidator = (p) => {
		const fields = structure[p].fields;
		let check = true;
		try {
			fields.forEach((e) => {
				if (e.required && !DATA[e.name]) check = false;
			});
		} catch (error) {}
		return check;
	};

	const formValidator = () => {
		let check = true;
		for (let i = 0; i < structure.length; i++) {
			if (!pageValidator(i)) {
				check = false;
				break;
			}
		}
		return check;
	};
	if (loading) {
		return (
			<div id="huro-app" className="app-wrapper">
				<div className="app-overlay" />
				<div id={"pageloader"} className={`pageloader is-active`} />
				<div id={"infraloader"} className={`infraloader is-active`} />
			</div>
		);
	}

	return (
		<Layout
			layout={2}
			mustAuth={false}
			sidePanel={true}
			title={"Medical Profile"}
		>
			<style>
				{`
					.main-sidebar.is-bordered {
						display: none !important;
					}

					.form-layout {
						padding-top: 3rem;
						padding-bottom: 3rem;
					}

					.h-avatar.is-xl {
						max-width: 200px !important;
						min-width: 100px !important;

					}
					.h-avatar.is-xl .avatar {
						width: auto !important;
						min-width: auto !important;
						max-width: 200px !important;
						border-radius: 0 !important;
						height: auto !important;
						margin: auto !important
					}
					.mobile-navbar.no-shadow, .navbar.mobile-navbar.is-hidden-desktop.is-hidden-tablet{
						display: none !important; 
					}
					#huro-app {
						min-height: 100vh !important;
					}
				`}
			</style>
			<div className="hub-header has-text-centered p-5">
				<div className="h-avatar is-xl mb-3 mt-5">
					<img
						className="avatar mb-3"
						src={require("../../assets/images/logo.png").default}
						data-demo-src={
							require("../../assets/images/logo.png").default
						}
						alt={"Logo"}
					/>
				</div>
				{/* <h3 className="title is-4 is-narrow">Patient Medical Record</h3> */}
				<p className="light-text">
					Please put a check mark by any symptoms that you have had recently.
					<br />
					Please check “none” if you have not noticed any of the symptoms listed
					in that category.
				</p>
			</div>
			{view === 1 ? (
				<InfoActionPage {...message} />
			) : (
				<SettingsLayout
					title={"Medical History Form"}
					data={DATA}
					comms={{}}
					endPoint={`/second-opinion/${identifier}/submit/`}
					btnText={"Submit Form"}
					hideCancel={true}
					successCallback={() => setView(1)}
					page={page}
					pageCount={structure.length}
					formWizard={true}
					formValidator={formValidator}
					formWizardNext={() => {
						if (pageValidator(page)) {
							setPage(page + 1);
						} else {
							notyf.open({
								type: "error",
								message: "Please fill all required fields to continue.",
							});
						}
					}}
					formWizardBack={() => setPage(page - 1)}
					consent={true}	
					disableSaving={booking?.paymentRequired}
				>
					<div
						className="form-body p-5"
						style={{ paddingTop: "0px !important" }}
					>
						<div className="form-fieldset">
							<div className="columns is-multiline">
								<FormContent
									{...props}
									structure={structure}
									updateProfile={updateProfile}
									PROFILE={DATA}
									formWizard={true}
									page={page}
									readOnly={booking?.paymentRequired}
								/>
							</div>
						</div>
					</div>
					<div style={{ display: "none" }}>
						<PaymentButton
							ref={paystack}
							amount={booking?.payment?.amount}
							email={booking?.patient?.email}
							successEndpoint={`/second-opinion/${booking?.payment?.id}/payment_status/`}
							closeCallback={() => window.location = ""}
						/>
					</div>
				</SettingsLayout>
			)}
		</Layout>
	);
};

const mapStateToProps = ({ user }) => {
	return { user };
};

const mapDispatchToProps = (dispatch) => {
	return {
		closePanel: (e) => dispatch(closePanel(e)),
		openPanel: (e) => dispatch(openPanel(e)),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(MedicalProfile2ndOpinion);
